"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactScrollSync = require("react-scroll-sync");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBTable = require("./HBTable.styles");
function HBTableFloatingScroller(_ref) {
  var setScrollerEl = _ref.setScrollerEl;
  return /*#__PURE__*/_react["default"].createElement(_reactScrollSync.ScrollSyncPane, null, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(Inner, {
    ref: setScrollerEl
  })));
}
var _default = exports["default"] = HBTableFloatingScroller; // -------------------------- Styles -------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFloatingScroller__Container",
  componentId: "sc-18xgvjv-0"
})(["position:sticky;bottom:0;z-index:", ";overflow:auto hidden;margin-top:-24px;height:24px;"], _HBTable.TABLE_Z_INDEX.BOTTOM);
var Inner = _styledComponents["default"].div.withConfig({
  displayName: "HBTableFloatingScroller__Inner",
  componentId: "sc-18xgvjv-1"
})(["height:1px;"]);
//# sourceMappingURL=HBTableFloatingScroller.js.map